export const PromptActionTypes = {
  TOGGLE_PROMPT: "TOGGLE_PROMPT",
};
